export default __webpack_public_path__ + "static/media/Intro1.ede90d4c.mp3";